import Button from "@material-ui/core/Button";
import { httpClient } from "api/httpClient";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { Confirm, useNotify, useRefresh, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

export const GeneratePalletsButton = ({
	orderProductArticle,
	disabledGeneratePallets,
	...props
}) => {
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const refresh = useRefresh();
	const [isRegeneration, setIsRegeneration] = React.useState(
		orderProductArticle.is_pallets_generated
	);
	const [loading, setLoading] = React.useState(false);

	const handleGenerate = async () => {
		setLoading(true);
		try {
			const { json } = await httpClient(
				`/order_product_article/${orderProductArticle.id}/generate-pallets`,
				{ method: "POST" }
			);

			handleClose();
			notify(
				translate(
					isRegeneration
						? "osfc.dialogs.regenerate-pallets.success"
						: "osfc.dialogs.generate-pallets.success"
				),
				"success"
			);
			setIsRegeneration(json.is_pallets_generated);
			refresh();
		} catch (error) {
			notifyError(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Button
				size="small"
				variant="outlined"
				color="primary"
				disabled={disabledGeneratePallets}
				onClick={handleOpen}
			>
				{translate(
					isRegeneration ? "osfc.buttons.regenerate-pallets" : "osfc.buttons.generate-pallets"
				)}
			</Button>
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate(
					isRegeneration
						? "osfc.dialogs.generate-pallets.title"
						: "osfc.dialogs.generate-pallets.title"
				)}
				content={translate(
					isRegeneration
						? "osfc.dialogs.regenerate-pallets.content"
						: "osfc.dialogs.generate-pallets.content"
				)}
				onConfirm={handleGenerate}
				onClose={handleClose}
				confirm="osfc.buttons.confirm"
			/>
		</>
	);
};
